module.exports = __webpack_public_path__ + "img/feat_easy.46c391d9.png";